// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { getCustomersWithPrefsAndOptions } from '@sophocles/entities/Customer/customerSelectors';
import { userSelector } from '@sophocles/entities/User';
import { userOptionSelector } from '@sophocles/entities/UserOption';
import { getPasswordVerifier } from '@sophocles/utils';

export const authTokenSelector = state =>
  state.authentication.status.isImpersonating ? state.authentication.impersonationToken : state.authentication.token;
export const poolIdSelector = state => state.authentication.pool;
const authUserSelector = state =>
  state.authentication.status.isImpersonating ? state.authentication.impersonating.user : state.authentication.user;
const selectedCustomer = state => state.authentication.customer;
export const isAuthenticatedSelector = state => state.authentication.status.isAuthenticated;

// TODO: This should not be used and we should be using useUser hook instead.
export const getAuthUserSelector = createSelector(
  authUserSelector,
  userSelector,
  userOptionSelector,
  (userId, users, userOptions) => {
    const authUser = users.get('' + userId, Map());
    return authUser.set('options', userOptions.get(authUser.get('options', -1) + '', Map()));
  },
);

export const getAuthUserCustomerSelector = createSelector(
  getAuthUserSelector,
  getCustomersWithPrefsAndOptions,
  (user, customers) => customers.get(user.get('customer', 0) + '', Map()),
);

export const getSelectedCustomerSelector = createSelector(
  selectedCustomer,
  getCustomersWithPrefsAndOptions,
  (customer, customers) => customers.get(customer ? customer.toString() : '0', Map()),
);

export const selectCustomer = customerId =>
  createSelector(
    state => customerId,
    getCustomersWithPrefsAndOptions,
    (customerId, customers) => customers.get(customerId, Map()).toJS(),
  );

export const getAuthUserCustomerPreferencesSelector = createSelector(getSelectedCustomerSelector, customer =>
  customer.get('preferences', null),
);

export const getIdentityProviders = state =>
  state.authentication.identityProviders ? state.authentication.identityProviders : [];

export const getCurrentChallenge = state => state.authentication.status.challenge;

export const getPasswordResetStatus = state => state.authentication.status.passwordReset;

export const getAuthStatus = state => state.authentication.status;

export const getAuthUserPasswordVerifier = state => {
  const { length, uppercase, lowercase, numbers, symbols } = state.authentication.passwordPolicy;
  return getPasswordVerifier(length, uppercase, lowercase, numbers, symbols);
};
